export default __webpack_public_path__ + "static/media/i-interior.47b08d13.svg";